/**
 * 搜索中心
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { message, Input, Card, Carousel, Button, List, Row, Col } from 'antd';
import model from '@/reducers/companyhelp/searchhelp/model';
import { split } from 'ts-toolset/dist/common/array';
import { getOverlap } from 'ts-toolset/dist/common/string';
import styles from './index.module.scss';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const pageSize = 8;

class Main extends React.PureComponent {
    constructor(props) {
        super(props);
        this.questionCarousel = React.createRef();
        this.state = {
            id: undefined,
            questionIndex: 1,
            leftDisabled: true,
            rightDisabled: false,
            showSearchResult: false,
            searchText: undefined,
            showSearchText: undefined,
        };
    }

    componentDidMount() {
        let { searchKey } = this.props.match.params;
        this.props.getQuestionList();
        searchKey && this.onSearch(searchKey);
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    onSearch = (searchText) => {
        if (searchText) {
            this.setState({ searchText, showSearchText: searchText, showSearchResult: true }, () => {
                this.props.getSearchList({ key: this.state.searchText });
            });
        } else {
            message.info('请输入关键字');
        }
    }

    searchResultClick = (title) => {
        this.props.history.push({ pathname: `/home/companyhelp/searchhelp/strategy/class/${title.id}/${this.state.searchText}` });
    }

    returnHome = () => {
        this.props.history.push({ pathname: `/home/companyhelp/` });
        // this.setState({ showSearchResult: false, searchText: undefined });
    }

    questionTitleClick = (item, title) => {
        this.props.history.push({ pathname: `/home/companyhelp/searchhelp/strategy/${item.id}/${title.id}` });
    }

    questionMoreClick = (item) => {
        this.props.history.push({
            pathname: `/home/companyhelp/searchhelp/strategy/${item.id}`,
            search: `titleName=运营公司 - ${item.className}`
        });
    }

    changeCarousel(direction) {
        let isNext = direction === 1,
            total = Math.ceil(this.props.questionList.length / pageSize),
            questionIndex = this.state.questionIndex + direction;

        if (questionIndex <= total && isNext) {
            this.setState({ questionIndex, rightDisabled: questionIndex === total, leftDisabled: false });
            this.questionCarousel.current.innerSlider.slickNext();
        }

        if (questionIndex >= 1 && !isNext) {
            this.setState({ questionIndex, rightDisabled: false, leftDisabled: questionIndex === 1 });
            this.questionCarousel.current.innerSlider.slickPrev();
        }
    }

    render() {

        let { leftDisabled, rightDisabled, searchText, showSearchText, showSearchResult } = this.state;

        // 构造问题列表数据结构
        let splits = split(this.props.questionList, pageSize).map(arr => split(arr, 4)),

            // 是否展示左右切换按钮
            hasLR = Math.ceil(this.props.questionList.length / pageSize) > 1;

        return (
            <div className={styles.merchantMain}>
                {/* 搜索栏目 */}
                <div className={styles.search}>
                    <img className={styles.background} src={require('@/assets/image/companyhelp/search-background.png').default} />
                    <div className={styles.form}>
                        <div className={styles.title}>欢迎使用普惠配送帮助中心</div>
                        <div><Input.Search size='large' value={searchText} onChange={(e) => this.setState({ searchText: e.target.value })} className={styles.input} placeholder='请输入关键字 例如：发货' enterButton onSearch={this.onSearch} /></div>
                    </div>
                </div>
                {/* 常见问题 */}
                <div className={styles.question}>
                    {/* <div className={styles.titleBar}>常见问题</div> */}
                    <div style={{ marginTop: 20 }}></div>
                    <Carousel dots={false} infinite={false} ref={this.questionCarousel}>
                        {splits.map((arr, index) => (
                            <div key={index} className={styles.cardWrap}>
                                {arr.map((items, index) => (
                                    <Row key={index} className={styles.cardRow} gutter={16}>
                                        {items.map(item => (
                                            <Col span={6} key={item.classId}>
                                                <Card className={styles.questionCard}>
                                                    <div className={styles.left}>
                                                        <div className={styles.content}>
                                                            <img src={item.imgUrl} />
                                                            <span className={styles.className}>{item.className}</span>
                                                        </div>
                                                    </div>
                                                    <div className={styles.right}>
                                                        <dl className={styles.questionList}>
                                                            {item.listStrategyInfo.length
                                                                ? item.listStrategyInfo.map(title => (<dd key={title.id} onClick={() => this.questionTitleClick(item, title)} title={title.title}>{title.title || '-'}</dd>))
                                                                : <dd>暂无数据</dd>
                                                            }
                                                        </dl>
                                                        <div className={styles.more} onClick={() => this.questionMoreClick(item, item.listStrategyInfo)}>更多 &gt;&gt;</div>
                                                    </div>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                ))}
                            </div>
                        ))}
                    </Carousel>
                    {
                        hasLR ?
                            <div className={styles.carouselIndex}>
                                <Button type='primary' shape='circle' icon={<LeftOutlined />} disabled={leftDisabled} onClick={() => this.changeCarousel(-1)} />
                                <span className={styles.btnSpance}></span>
                                <Button type='primary' shape='circle' icon={<RightOutlined />} disabled={rightDisabled} onClick={() => this.changeCarousel(1)} />
                            </div>
                            : null
                    }
                </div>
                {/* 搜索结果 */}
                {showSearchResult ?
                    <div className={styles.result}>
                        <List
                            bordered
                            dataSource={this.props.searchList}
                            renderItem={item => {
                                let text = '-';
                                if (item.title) {
                                    let intersection = getOverlap(showSearchText, item.title);
                                    let splits = item.title.split(intersection);
                                    text = <span>{splits[0]}<span className={styles.strong}>{intersection}</span>{splits[1]}</span>;
                                }
                                return (<List.Item key={item.id} onClick={() => this.searchResultClick(item)}>{text}</List.Item>);
                            }}
                            header={
                                <div className={styles.header}>
                                    <span>关于 <span className={styles.strong}>“{showSearchText}”</span> 一共搜出<span className={styles.strong}> {this.props.searchList.length} </span>个结果</span>
                                    <Button type='primary' style={{ float: 'right', marginRight: '15px' }} onClick={this.returnHome}>返回</Button>
                                </div>
                            }
                        />
                    </div>
                    : null
                }
            </div>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object, // router match
    history: PropTypes.object,
    addOneBreadcrumbPath: PropTypes.func, // 添加一个面包屑导航子级
    keepSecondNavBreadcrumb: PropTypes.func, // 保持两级面包屑导航

    questionList: PropTypes.array,
    getQuestionList: PropTypes.func,

    searchList: PropTypes.array,
    getSearchList: PropTypes.func,

    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    questionList: state.searchhelp.questionList,
    searchList: state.searchhelp.searchList
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);